import { render } from "./CartCardRow.vue?vue&type=template&id=0ef250f5&scoped=true&ts=true"
import script from "./CartCardRow.vue?vue&type=script&lang=ts"
export * from "./CartCardRow.vue?vue&type=script&lang=ts"

import "./CartCardRow.vue?vue&type=style&index=0&id=0ef250f5&scoped=true&lang=css"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef250f5"]])

export default __exports__